import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

import styles from './account-trigger.module.css';

interface NavigationAccountTriggerSignature {
  Args: {};
}

const NavigationAccountTrigger = <template>
  <div class={{styles.container}}>
    <PrismIcon @color="inherit" @name="circle-user" @size="large" />
  </div>
</template> satisfies TOC<NavigationAccountTriggerSignature>;

export default NavigationAccountTrigger;
